/** The first-use location belongs to the shell; its content belongs to plugins. */
import type { PanelEntry } from "../lib/api";
import { PanelView } from "../panel/PanelView";
import { SurfaceVisibility } from "../panel/SurfaceHost";

export function SetupPage({ panels, onToast, connected = true }: {
  panels: PanelEntry[];
  onToast: (message: string, tone: "good" | "critical") => void;
  connected?: boolean;
}) {
  const entries = panels.filter(panel => panel.bootstrap === true && panel.audience === "owner");
  return <section className="setup" data-testid="setup-page">
    {!connected ? <p role="status">正在恢复连接，确认后可继续。</p> : null}
    {entries.length ? <SurfaceVisibility.Provider value={connected}>
      {entries.map(entry => <PanelView key={`${entry.key}:${entry.generation_id}`} panelKey={entry.key}
        onToast={onToast} seatKnown={connected} panels={panels} presentation="embedded" />)}
    </SurfaceVisibility.Provider> : <div role="status"><h1>正在准备首次使用</h1>
      <p>当前 IP 尚未提供首次使用界面。请联系实例管理者检查已启用的插件。</p></div>}
  </section>;
}
